var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CommentResponseTemplate"},[_c('div',{staticClass:"CommentResponseTemplate-title"},[_vm._v(" "+_vm._s(_vm.$t('unratedAnswer'))+" ")]),_c('div',{staticClass:"CommentResponseTemplate-response"},[_vm._v(" "+_vm._s(_vm.response.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }